
export const EVENTS:any=[
 {t:'Exportflaute',s:'Schwache Nachfrage aus China und den USA bremst die Industrie.',crisis:1,gr:-.4,g:{unt:-3,arb:-2}},
 {t:'Steuerschätzung über Erwartung',s:'Der Arbeitskreis Steuerschätzungen rechnet mit Mehreinnahmen.',b:4},
 {t:'Gaspreisschock',s:'Lieferengpässe treiben die Gaspreise.',crisis:1,gr:-.15,iss:{energie:12}},
 {t:'Brücke gesperrt',s:'Eine wichtige Autobahnbrücke muss überraschend gesperrt werden.',iss:{infra:8}},
 {t:'Hitzesommer',s:'Dürre und Waldbrände bestimmen die Nachrichten.',iss:{klima:8}},
 {t:'Rekordmieten',s:'Eine neue Studie meldet die stärksten Mietsteigerungen seit Jahren.',iss:{wohnen:8}},
 {t:'Pleitewelle bei Pflegeheimen',s:'Mehrere große Heimbetreiber melden Insolvenz an.',iss:{pflege:10}},
 {t:'Streit in der Koalition',s:'Ein Minister des Partners kritisiert die Regierung öffentlich.',coal:-8},
 {t:'Gute Konjunkturdaten',s:'Auftragseingänge und Konsum ziehen an.',gr:.3,g:{unt:2}},
 {t:'Jahrhunderthochwasser',s:'Flut in Süd- und Ostdeutschland. Der Bund sagt Milliardenhilfen zu.',crisis:1,b:-6,g:{fam:-1,rent:-1}},
 {t:'Bahnstreik',s:'Mehrere Tage steht der Fernverkehr still.',gr:-.05,g:{arb:-2,jung:-2},iss:{infra:3}},
];
